// Cloudinary paths for onboarding assets. Centralized here so version IDs stay
// in lockstep when assets are re-uploaded.
export const ONBOARDING_IMAGE_PATH =
  '/v1730118747/custommade/assets/Onboarding/Onboarding_SS_00.avif';

export const ONBOARDING_VIDEO_PATHS = [
  '', // step 0 uses the onboarding image
  '/v1731660557/video/suitsupply/custom-made/Onboarding_SS_01.webm',
  '/v1731660559/video/suitsupply/custom-made/Onboarding_SS_02.webm',
  '/v1731660562/video/suitsupply/custom-made/Onboarding_SS_03.webm',
  '/v1731660568/video/suitsupply/custom-made/Onboarding_SS_04.webm',
] as const;
